import { Routes } from '@angular/router';
import { authGuard, clientContextGuard } from './components/login/auth.guard';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  // 🔓 Login público
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },

  // 🚫 Autenticado pero sin clientes asignados (Usuarios_Clientes vacío)
  {
    path: 'sin-acceso',
    canActivate: [authGuard],
    loadComponent: () => import('./components/pages/sin-acceso/sin-acceso').then(m => m.SinAcceso)
  },

  // 🔐 App protegida
  // authGuard        → ¿hay sesión?
  // clientContextGuard → ¿tiene al menos un cliente permitido?
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard, clientContextGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'medidor/:id',
        loadComponent: () => import('./components/pages/medidor-detalle/medidor-detalle').then(m => m.MedidorDetalle)
      },
      {
        path: 'reportes/lecturas',
        loadComponent: () => import('./components/pages/reportes/reporte-lecturas/reporte-lecturas').then(m => m.ReporteLecturas)
      },
      {
        path: 'reportes/consumo-trimestral',
        loadComponent: () => import('./components/pages/reportes/reporte-consumo-trimestral/reporte-consumo-trimestral').then(m => m.ReporteConsumoTrimestral)
      },
      {
        path: 'alarma-detalle/:meterId',
        loadComponent: () => import('./components/pages/alarma-detalle/alarma-detalle').then(m => m.AlarmaDetalle)
      },
      {
        path: 'produccion-grupo',
        loadComponent: () => import('./components/produccion/grupo/produccion-grupo/produccion-grupo').then(m => m.ProduccionGrupo)
      },
      {
        // El mapa ya navegaba aquí para los resúmenes de Calidad, pero la ruta
        // no existía: caía en el comodín y rebotaba al dashboard sin avisar.
        path: 'calidad-aplicacion',
        loadComponent: () =>
          import('./components/pages/calidad/calidad-aplicacion/calidad-aplicacion')
            .then(m => m.CalidadAplicacion)
      },
      {
        /*
         * Módulo de administración: un contenedor con su propio rail de
         * secciones, en vez de tres entradas sueltas en el menú del header.
         *
         * El rail se filtra por permiso, pero la autorización real la hacen
         * los endpoints: entrar por URL directa muestra la pantalla vacía,
         * nunca los datos.
         */
        path: 'administracion',
        loadComponent: () =>
          import('./components/pages/administracion/administracion-layout/administracion-layout')
            .then(m => m.AdministracionLayout),
        children: [
          {
            path: 'clientes',
            loadComponent: () =>
              import('./components/pages/administracion/administracion-clientes/administracion-clientes')
                .then(m => m.AdministracionClientes)
          },
          {
            /*
             * Sitios, aplicaciones y medidores de un cliente. Cuelga de
             * Clientes y no del rail: la infraestructura siempre es DE un
             * cliente, y así «Clientes» queda marcado en el rail mientras se
             * trabaja en ella.
             */
            path: 'clientes/:iIdCliente/infraestructura',
            loadComponent: () =>
              import('./components/pages/administracion/administracion-infraestructura/administracion-infraestructura')
                .then(m => m.AdministracionInfraestructura)
          },
          {
            /*
             * Todo lo de personas: la lista agrupada, sus accesos y permisos, y
             * el alta en modal. Eran dos secciones («Alta de usuario» y
             * «Accesos y permisos») que pedían el mismo permiso y se estorbaban.
             */
            path: 'usuarios',
            loadComponent: () =>
              import('./components/pages/administracion/administracion-accesos/administracion-accesos')
                .then(m => m.AdministracionAccesos)
          },
          // La ruta vieja sigue viva: hay enlaces guardados apuntando ahí.
          { path: 'accesos', redirectTo: 'usuarios' },
          // Sin sección, el contenedor redirige a la primera que el usuario
          // pueda ver: cuál sea depende de sus permisos, así que no se puede
          // fijar un redirectTo aquí.
        ]
      },
      {
        path: 'concesiones',
        loadComponent: () =>
          import('./components/pages/concesiones/concesion-list/concesion-list')
            .then(m => m.ConcesionList)
      },
      {
        path: 'concesiones/nuevo',
        loadComponent: () =>
          import('./components/pages/concesiones/concesion-create/concesion-create')
            .then(m => m.ConcesionCreate)
      },
      {
        path: 'concesiones/editar/:id',
        loadComponent: () =>
          import('./components/pages/concesiones/concesion-edit/concesion-edit')
            .then(m => m.ConcesionEdit)
      },
      {
        path: 'concesiones/:id',
        loadComponent: () =>
          import('./components/pages/concesiones/concesion-detalle/concesion-detalle')
            .then(m => m.ConcesionDetalle)
      },
      // nuevos..
      {
        path: '', // raíz → redirige a dashboard
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },

  // ❗ Rutas no existentes → raíz
  { path: '**', redirectTo: '' }
];
